import { ReactNode } from "react";
import { ReactComponent as FrameBack } from "images/frame_back.svg";
import "./style.css";

type Props = {
  children: ReactNode;
};

function TalaeraBackground(props: Props) {
  return (
    <div className={"talaera-background-container"}>
      {props.children}

      <FrameBack className="frame-back" />
    </div>
  );
}

export default TalaeraBackground;
